import { httpOrderService } from "../http-service";
import { Order, OrderResponse, SearchParams } from "../model/Order";

const getAll = async (
  search: string,
  searchParams: SearchParams,
  pageNumber: number,
  pageSize: number,
  orderBy: string,
  sortDirection: string,
) => {
  if(pageNumber===0)
    pageNumber=1;
//console.log(searchParams)
const params = new URLSearchParams({
    search: search || "",
    pageNumber: String(pageNumber),
    pageSize: String(pageSize),
    orderBy: orderBy || "",
    sortDirection: sortDirection || "",
    fireNumber: searchParams.fireNumber|| "",
    crewNumber: searchParams.crewNumber || "",
    orderFrom: searchParams.orderFrom|| "",
    forestArea: searchParams.forestArea|| "",
    orderStatus: searchParams.orderStatus|| "",
    orderType: searchParams.orderType|| "",
    orderedBy:searchParams.orderedBy.toString(),
    startDate: searchParams.startDate ? searchParams.startDate.toUTCString() : "",
    endDate: searchParams.endDate ? searchParams.endDate.toUTCString() : "",
  });

  // if (startDate) {
  //   params.append('startDate', startDate.toDateString());
  // }

  // if (endDate) {
  //   params.append('endDate', endDate.toDateString());
  // }

  // if (status) {
  //   params.append('status', status.toString());
  // }

  // if (name) {
  //   params.append('name', name);
  // }

  const data = await httpOrderService.get<OrderResponse>(`/order?${params}`);

  return data;
};

 
const getById = async (
  id : string
) => {
  const data = await httpOrderService.get<Order>(`/order/id/${id}`);
  return data;
};

const getByOrderNumber = async (
  orderNumber : string
) => {
  const data = await httpOrderService.get<Order>(`/order/order-number/${orderNumber}`);
  return data;
};


 
const create = async (newOrder: Order) => {

  try {
    const order = JSON.stringify(newOrder);
    console.log(order);

    const response = await httpOrderService.post<Order>(
      `/order`,
      newOrder,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    if (response.status === 200 || response.status === 202) {
      return {orderNumber:response.data.orderNumber, success: true };
    } else {
      throw new Error('Failed to create a order'); // Throw an error for non-200 status codes
    }
  } catch (error:any) {
    console.error('Error creating an order:', error?.response?.data?.detail);
    return { success: false, error: error?.response?.data?.detail || 'Unknown error' }; // Return error message
  }
};

const update = async (newOrder: Order) => {
  try {
    const order = JSON.stringify(newOrder);
    console.log(order);
    const response = await httpOrderService.put<Order>(
      `/order`,
      newOrder,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    if (response.status === 200 || response.status === 202) {
      return { success: true };
    } else {
      throw new Error('Failed to update an order'); // Throw an error for non-200 status codes
    }
  } catch (error:any) {
    console.error('Error updating an order:', error?.response?.data?.detail);
    return { success: false, error: error?.response?.data?.detail || 'Unknown error' }; // Return error message
  }
};

const addComment = async (newOrder: Order) => {
  try {
    const order = JSON.stringify(newOrder);
    console.log(order);
    const response = await httpOrderService.post<Order>(
      `/order/comment`,
      newOrder,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    if (response.status === 200 || response.status === 202) {
      return { success: true };
    } else {
      throw new Error('Failed to save a comment'); // Throw an error for non-200 status codes
    }
  } catch (error:any) {
    console.error('Error saving the comment:', error?.response?.data?.detail);
    return { success: false, error: error?.response?.data?.detail || 'Unknown error' }; // Return error message
  }
};

const updateOrderSummary = async (updatedOrder: Order) => {
  try {
    const order = JSON.stringify(updatedOrder);
    console.log(order);

    const response = await httpOrderService.put<Order>(
      `/order/order-summary`,
      updatedOrder,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    if (response.status === 200 || response.status === 202) {
      return { success: true };
    } else {
      throw new Error('Failed to update an order summary'); // Throw an error for non-200 status codes
    }
  } catch (error:any) {
    console.error('Error updating order summary:', error?.response?.data?.detail);
    return { success: false, error: error?.response?.data?.detail || 'Unknown error' }; // Return error message
  }
};

const deleteOrder = async (id: string) => {
  try {
    // const order = JSON.stringify(newOrder);
    // console.log(order);

    const response = await httpOrderService.delete<string>(`/order/${id}`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    if (response.status === 200 || response.status === 202) {
      return { success: true };
    } else {
      throw new Error('Failed to delete the order'); // Throw an error for non-200 status codes
    }
  } catch (error:any) {
    console.error('Error deleting the order:', error?.response?.data?.detail);
    return { success: false, error: error?.response?.data?.detail || 'Unknown error' }; // Return error message
  }
};



export const OrderService = {
  getAll,
  getById,
  getByOrderNumber,
  create,
  update,
  updateOrderSummary,
  deleteOrder,
  addComment,
};